import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { TextField } from '@mui/material';

interface PhoneProps {
  value?: string;
  onValueChange: (value: string) => void;
  variant?: 'outlined' | 'standard';
  label?: string;
  error?: boolean;
  helperText?: string | boolean;
  name?: string;
  placeholder?: string;
}

const PhoneTextField = React.forwardRef<PatternFormatProps<never>, PhoneProps>(
  (props, ref) => {
    const {
      value,
      onValueChange,
      variant,
      label,
      error,
      helperText,
      ...other
    } = props;

    return (
      <PatternFormat
        {...other}
        label={label}
        onValueChange={value => onValueChange(value.formattedValue)}
        customInput={TextField}
        helperText={helperText}
        error={error}
        variant={variant}
        value={value}
        style={{ width: '100%', marginBottom: 16 }}
        format="(##) #####-####"
        getInputRef={ref}
        mask="_"
        type="tel"
      />
    );
  }
);

PhoneTextField.displayName = 'PhoneTextField';

export default PhoneTextField;
